import { useNavigate } from "react-router-dom"
import { Input, Select } from "antd"
import { BsFillTrashFill, BsPencilSquare } from "react-icons/bs"
import PaginationComponent from "../../../../components/pagination/PaginationComponent"
import Loading from "../../../../components/loading/Loading"
import useActualScore from "./useActualScore"
import { SearchOutlined } from "@ant-design/icons"
import ActionButtonGradient from "../../../../components/button/ActionButtonGradient"

// ============= CONSTANTS =============
const LIMIT_OPTIONS = [
    { label: 10, value: 10 },
    { label: 25, value: 25 },
    { label: 50, value: 50 },
    { label: 100, value: 100 },
]

const ActualScore = ({
    active,
    project_id, 
    payload, 
    users, 
    userCalibration, 
    pageUsers, 
    totalPageUsers, 
    changePageUsers,
    handleShow,
    setDeleteID,
    setName,
    setIsRatingQuota,
    setFilterNameUsers,
    limitUsers,
    filterName,
    setFilterLimitUsers,
    divisions,
    setFilterDivisionUsers,
    onRefresh
}) => {
    const navigate = useNavigate()

    const {
        fileInputKey,
        handleFileChange,
        postActualScore,
        logs,
        loadingPagestate
    } = useActualScore()

    const handleDeleteClick = (user) => {
        handleShow()
        setDeleteID(`${project_id}/${user.ID}`)
        setName(`Calibration Data for ${user.Name}`)
        setIsRatingQuota(false)
    }

    return(
        <div>
            <Loading state={loadingPagestate}/>
            
            {!active && (
                <form onSubmit={(e) => {
                    e.preventDefault()
                    postActualScore(project_id, onRefresh)
                }}>
                    <input
                        key={fileInputKey}
                        type="file" 
                        className="form-control" 
                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        onChange={handleFileChange} 
                    />
                    <div align="right" className="mt-2">
                        <ActionButtonGradient
                            type="submit"
                            variant="primary"
                            children={"Upload File"}
                        />
                    </div>
                </form>
            )}

            {logs && (
                <div className="logs">
                    <p>The following NIK has an error on the column data. Please double check the excel file that you submitted:</p>
                    {logs.map((log, index) => (
                        <p key={index}>{log}</p>
                    ))}
                </div>
            )}

            <div>
                <div className="d-flex justify-content-between align-items-center my-3">
                    <div className="d-flex gap-2" style={{ flex: 1 }}>
                        <Input 
                            placeholder="Search by employee name/nik" 
                            allowClear 
                            onChange={setFilterNameUsers} 
                            value={filterName} 
                            style={{ width: '280px', fontSize: '16px' }}
                            prefix={<SearchOutlined style={{ color: '#bfbfbf' }} />}
                        />
                        <Select
                            placeholder="Select division"
                            style={{ width: 200, height: 35 }}
                            onChange={setFilterDivisionUsers}
                            allowClear
                            fontSize="16px"
                        >
                            {divisions.map((div, index) => (
                                <Select.Option key={index} value={div}>
                                    {div}
                                </Select.Option>
                            ))}
                        </Select>
                    </div>
                    <ActionButtonGradient
                        onClick={() => navigate(`/project-list/calibration/${payload.ID}`)}
                        variant="success"
                        children={"Create Calibration Data"}
                    />
                </div>
                
                <div className="table-responsive mt-3">
                    <table className="table align-items-center">
                        <thead>
                            <tr>
                                <th scope="col" className="text-center">Employee</th>
                                <th scope="col" className="text-center">Y2 Rating</th>
                                <th scope="col" className="text-center">Y1 Rating</th>
                                <th scope="col" className="text-center">Actual Score</th>
                                <th scope="col" className="text-center">Actual Rating</th>
                                {payload?.ProjectPhases?.map((pp, index) => (
                                    <th key={index} scope="col" className="text-center">{pp.Phase.Name}</th>
                                ))}
                                <th scope="col" className="text-center">SPMO</th>
                                <th scope="col" className="text-center"></th>
                                <th scope="col" className="text-center"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {users?.map((user, index) => (
                                <tr key={index}>
                                    <td>
                                        <b>{user.Name}</b> ({user.Nik})
                                        <br />{user.OrganizationUnit}
                                    </td>
                                    <td className="text-center">{user.ActualScores?.[0]?.Y2Rating}</td>
                                    <td className="text-center">{user.ActualScores?.[0]?.Y1Rating}</td>
                                    <td className="text-center">
                                        {user.ActualScores?.[0]?.ActualScore?.toFixed(2)}
                                    </td>
                                    <td className="text-center">{user.ActualScores?.[0]?.ActualRating}</td>
                                    {userCalibration[user.ID]}
                                    <td className="text-center">
                                        <button 
                                            className="btn" 
                                            onClick={() => navigate(`/project-list/calibration/${project_id}/${user.ID}`)}    
                                            title="Edit user"
                                            style={{
                                                padding: '8px 12px',
                                                borderRadius: '5px',
                                                border: '1px solid #02B4CC',
                                                backgroundColor: 'transparent',
                                                color: '#02B4CC',
                                                cursor: 'pointer',
                                                fontSize: '14px',
                                                fontWeight: '500',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '6px',
                                                transition: 'all 0.2s ease'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor = '#02B4CC';
                                                e.currentTarget.style.color = 'white';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor = 'transparent';
                                                e.currentTarget.style.color = '#02B4CC';
                                            }}
                                        >
                                            <BsPencilSquare/>
                                        </button>
                                    </td>
                                    <td className="text-center">
                                        <button 
                                            className="btn" 
                                            onClick={() => handleDeleteClick(user)}   
                                            title="Delete user"
                                            style={{
                                                padding: '8px 12px',
                                                borderRadius: '5px',
                                                border: '1px solid #dc3545',
                                                backgroundColor: 'transparent',
                                                color: '#dc3545',
                                                cursor: 'pointer',
                                                fontSize: '14px',
                                                fontWeight: '500',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '6px',
                                                transition: 'all 0.2s ease'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor = '#dc3545';
                                                e.currentTarget.style.color = 'white';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor = 'transparent';
                                                e.currentTarget.style.color = '#dc3545';
                                            }}
                                        >
                                            <BsFillTrashFill/>
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                
                <div align="right">
                    <Select
                        style={{ marginLeft: "0.5rem" }}
                        value={limitUsers}
                        options={LIMIT_OPTIONS}
                        onChange={setFilterLimitUsers}
                    />
                </div>
                
                <div className="table-responsive">
                    <PaginationComponent
                        current={pageUsers}
                        totalPages={totalPageUsers}
                        navigate={changePageUsers}
                    />
                </div>
            </div>
        </div>
    )
}

export default ActualScore